import { useContext } from 'react';
import { AngularContext } from 'react-app';
import { Button } from 'react-bootstrap';
import prodPathReplace from 'shared/prod-path-rewrite';
import t from 'react-translate';
import moment from 'moment';
import { config } from '@config/pendo.config.json';

const UNRELEASE_IMAGE = 'images/unrelease-feature.gif';
const IMAGE_HEIGHT = 140;
const IMAGE_WIDTH = 150;

type Props = {
  date?: string;
};

const UnreleasedFeature = ({ date }: Props) => {
  const { injectServices } = useContext(AngularContext);
  const [$state, CurrentUserManager] = injectServices(['$state', 'CurrentUserManager']);

  const goToDashboard = () => {
    if (CurrentUserManager.isCourseAdminInAtLeastOneCourse() || CurrentUserManager.getProgramsAsAdminCount()) {
      $state.go('course-admin-dashboard', null, { replace: true });
    } else if (CurrentUserManager.isSupervisor() || CurrentUserManager.getProgramsAsMentorCount()) {
      $state.go('course-supervisor-dashboard', null, { replace: true });
    } else {
      $state.go('dashboard', null, { replace: true });
    }
  };

  const buttonLabel = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PROGRAM_CLOSED.BACK_TO_DASHBOARD();

  return (
    <div className='unreleased-section d-flex flex-column align-items-center justify-content-center'>
      <img
        src={prodPathReplace(UNRELEASE_IMAGE)}
        alt={t.MENTORING_PROGRAMS.PARTICIPANT_HOME.UNRELEASED_FEATURE.TITLE()}
        height={IMAGE_HEIGHT}
        width={IMAGE_WIDTH}
      />
      <div className='heading-4 mt-6 mb-1'>
        {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.UNRELEASED_FEATURE.TITLE()}
      </div>
      <div className='text-body-large description mb-6'>
        {date
          ? t.MENTORING_PROGRAMS.PARTICIPANT_HOME.UNRELEASED_FEATURE.DESCRIPTION(moment(date).format('MMMM DD, YYYY hh:mm A'))
          : t.MENTORING_PROGRAMS.PARTICIPANT_HOME.UNRELEASED_FEATURE.DESCRIPTION_NO_DATE()}
      </div>
      <Button
        size='lg'
        variant='primary'
        onClick={goToDashboard}
        data-qa={config.pendo.athena.mentorshipProgram.participantHome.redirectToDashboard.programUnreleased}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default UnreleasedFeature;
